import { TimeWindow } from '@conversed/shared/src/central/types/time-window.type';
import type { HomeDataDTO } from './home.dto';

// Default time window for the Studio Performance metrics in the overview payload
export const DEFAULT_STUDIO_PERFORMANCE_WINDOW: TimeWindow =
  TimeWindow.Last7Days;

export const DEFAULT_HOME_DATA: HomeDataDTO = {
  botName: 'Unknown Bot',
  totalQuestions: 0,
  aiAccuracy: 0,
  activeUsers: 0,
};
